"use strict";
/* This is a generated file, do not edit */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphNode = void 0;
var Param_1 = require("../../rmf_building_map_msgs/msg/Param");
var GraphNode = /** @class */ (function () {
    function GraphNode(fields) {
        if (fields === void 0) { fields = {}; }
        this.x = fields.x || 0;
        this.y = fields.y || 0;
        this.name = fields.name || '';
        this.params = fields.params || [];
    }
    GraphNode.validate = function (obj) {
        var e_1, _a;
        if (typeof obj['x'] !== 'number') {
            throw new Error('expected "x" to be "number"');
        }
        if (typeof obj['y'] !== 'number') {
            throw new Error('expected "y" to be "number"');
        }
        if (typeof obj['name'] !== 'string') {
            throw new Error('expected "name" to be "string"');
        }
        if (!Array.isArray(obj['params'])) {
            throw new Error('expected "params" to be an array');
        }
        try {
            for (var _b = __values(obj['params'].entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), i = _d[0], v = _d[1];
                try {
                    Param_1.Param.validate(v);
                }
                catch (e) {
                    throw new Error("in index " + i + " of \"params\":\n  " + e.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    GraphNode.FullTypeName = 'rmf_building_map_msgs/msg/GraphNode';
    return GraphNode;
}());
exports.GraphNode = GraphNode;
/*
float32 x
float32 y
string name
Param[] params

*/
